import type { CalculatorMeta } from '../../types/calculator';

const meta: CalculatorMeta = {
  route: '/gravel-calculator',
  component: () => import('../../routes/GravelCalculator.svelte'),
  card: {
    id: 'gravel-calculator',
    title: 'Gravel Calculator',
    description: 'Calculate how much gravel, sand, soil, mulch, or stone you need for your landscaping project. Get volume, weight, bags needed, and cost estimates.',
    icon: 'landscape',
    iconBgClass: 'bg-amber-50',
    iconTextClass: 'text-amber-600',
    href: '/gravel-calculator',
    category: 'Real Estate',
  },
  seo: {
    title: 'Gravel Calculator – Calculate Landscape Material Needs',
    description: 'Free gravel calculator to estimate cubic yards, tons, bags needed, and cost for landscaping projects. Supports gravel, sand, soil, mulch, and crushed stone.',
  },
};

export default meta;